// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2NCNZ","validationTips":"StatementDescriptor_validationTips__2ut4F"};